import * as React from "react";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import { AddCircleOutline as AddCircleOutlineIcon } from "@mui/icons-material";
const getStyles = (colorStyle, width) => {
  let styles = {
    backgroundColor: "rgb(30, 144, 255)",
    color: "#000",
    fontSize: 16,
    height: 32,
    padding: 0,
    // marginBottom: 16,
    width: width,
    "&:hover": {
      color: "#F0F2F5",
      backgroundColor: "#00008B",
    },
  };
  switch (colorStyle) {
    case "yesColor":
      styles.backgroundColor = "#1E90FF";
      styles.color = "#000";
      styles["&:hover"].backgroundColor = "#00008B";
      styles["&:hover"].color = "#F0F2F5";
      break;
    case "noColor":
      styles.backgroundColor = "#808080";
      styles.color = "#F0F2F5";
      styles["&:hover"].backgroundColor = "#DCDCDC";
      styles["&:hover"].color = "#000";
      break;
    default:
      break;
  }
  return styles;
};

export default function DialogButton(props) {
  return (
    <Button
      component="label"
      variant="contained"
      disabled={props.disabled}
      onClick={() => props.onClick()}
      sx={getStyles(props.colorStyle, props.width)}
    >
      {props.label}
      {/* <VisuallyHiddenInput type="file" /> */}
    </Button>
  );
}
